import { C_OUTLINE_VARIANT, type Theme } from "@schaeffler-commerce/design-system";

export const vendorAndIframeStyles = (theme: Theme) => ({
  "#cadIframe": {
    [theme.breakpoints.up("tablet")]: {
      height: "650px",
    },
  },
  "#configuratorIframe, #calcIframe": {
    height: "1050px",
    [theme.breakpoints.down("tablet")]: {
      maxHeight: "80vh",
    },
  },
  "#mmIframe": {
    height: "800px",
    [theme.breakpoints.down("tablet")]: {
      maxHeight: "80vh",
    },
  },
  ".gm-svpc": {
    "& div": {
      width: "40px",
      height: "40px",
    },
  },
  ".scha__sp__map .gm-style-moc": {
    zIndex: "1 !important",
  },
});

// Migrated from qualtrics.less. Targets DOM injected by the Qualtrics
// third-party script (React does not own this markup). Slots:
// #pdpQuickFeedback (PDP QualtricsContainer) and #qualtricsScanning
// (DesktopScanDMCTeaser). Typography mixins expanded to their exact LESS
// values (cssVariables.less); the .rounded-card mixin to 8px radius + 1px
// outline-variant border. !important flags preserved - they fight the
// Qualtrics stylesheet.
export const qualtricsStyles = () => ({
  "#pdpQuickFeedback:not(:empty)": {
    marginTop: "30px",
  },
  "#qualtricsScanning:empty": {
    display: "none",
  },
  ".QSI__EmbeddedFeedbackContainer": {
    margin: "0 !important",
    padding: "20px",
    "& fieldset": {
      "& > * + *": {
        marginTop: "16px !important",
      },
    },
    position: "relative",
    display: "block",
    "&::after": {
      content: '""',
      borderRadius: "8px",
      border: `1px solid ${C_OUTLINE_VARIANT}`,
      position: "absolute",
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      zIndex: 1,
      pointerEvents: "none",
    },
  },
  ".QSI__EmbeddedFeedbackContainer_QuestionText": {
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0.1px !important",
    marginBottom: "0 !important",
  },
  ".QSI__EmbeddedFeedbackContainer_OpenText": {
    fontSize: "16px !important",
    lineHeight: "24px !important",
    letterSpacing: "0.5px !important",
    padding: "8px 10px !important",
  },
  ".QSI__EmbeddedFeedbackContainer_TextButton": {
    fontSize: "14px !important",
    lineHeight: "20px !important",
    letterSpacing: "0.25px !important",
    padding: "14px 22px !important",
    minHeight: "50px",
    color: "white !important",
    transition: "all 0.2s ease",
  },
});
